import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { deletePaymentDiscount } from '../../../../../../../../crud/payments_api/payment_discounts';
import { toast } from 'react-toastify';
import { X } from 'react-bootstrap-icons';


interface RenderDeleteDiscountsModalProps {
  show: boolean;
  handleClose: () => void;
  // Si no tienes definida la interfaz Discount, podrías usar any[] en lugar de Discount[]
  discountsToDelete: any[];
  setDiscounts: any;
}



const DeleteDiscount: React.FC<RenderDeleteDiscountsModalProps> = ({
  show,
  handleClose,
  discountsToDelete,
  setDiscounts
}) => {

  const [isDeleting, setIsDeleting] = useState(false);

  // Ajuste en tu RenderDeleteDiscountsModal:

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      for (const discount of discountsToDelete) {
        await deletePaymentDiscount(discount.payment_discount_id);
        toast.success(`Descuento "${discount.payment_discount_name}" eliminado exitosamente.`);
      }

      // Usamos el callback: (prevDiscounts: any[]) => new array
      setDiscounts((prevDiscounts: any[]) =>
        prevDiscounts.filter((d: any) =>
          !discountsToDelete.some((del: any) => del.payment_discount_id === d.payment_discount_id)
        )
      );

      handleClose();
    } catch (error) {
      console.error('Error al eliminar descuentos:', error);
      toast.error('Ocurrió un error al eliminar los descuentos.');
    } finally {
      setIsDeleting(false);
    }
  };


  return (
    <Modal show={show} onHide={handleClose} className='modal-descuentos'>
      <Modal.Header>
        <div className='form-modal-title-container'>
          <Modal.Title className='form-modal-title'>Eliminar descuento</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={handleClose}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        {discountsToDelete.length === 0 ? (
          <p className='p-delete-descuento'>No hay descuentos para eliminar.</p>
        ) : discountsToDelete.length > 1 ? (
          <p className='p-delete-descuento'>
            {`¿Estás seguro de que deseas eliminar los ${discountsToDelete.length} descuentos seleccionados? Esta acción no se puede deshacer.`}
          </p>
        ) : (
          <p className='p-delete-descuento'>
            ¿Estás seguro de que deseas eliminar el descuento <strong>"{discountsToDelete[0].payment_discount_name}"</strong>? Esta acción no se puede deshacer.
          </p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button 
            className="form-button-cancel" 
            variant='none' 
            onClick={handleClose}
            disabled={isDeleting}
          >
            Cancelar
          </Button>
          <Button 
            className="form-button-delete" 
            onClick={handleDelete} 
            variant="danger"
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Eliminando...
              </>
            ) : (
              'Eliminar'
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteDiscount;

